// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-control-label {
  font-size: var(--main-font-size-control-label);
}
.lsn-control-label .lsn-required-tag {
  color: var(--main-red);
  margin-right: 3px;
}
.lsn-control-label strong,
.lsn-control-label span,
.lsn-control-label b,
.lsn-control-label u,
.lsn-control-label i:not(.far),
.lsn-control-label ul,
.lsn-control-label li {
  all: revert;
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/Form/components/Label/Label.less"],"names":[],"mappings":"AAAA;EACE,8CAAA;AACF;AAFA;EAII,sBAAA;EACA,iBAAA;AACJ;AANA;;;;;;;EAeI,WAAA;AAAJ","sourcesContent":[".lsn-control-label {\n  font-size: var(--main-font-size-control-label);\n\n  .lsn-required-tag {\n    color: var(--main-red);\n    margin-right: 3px;\n  }\n\n  strong,\n  span,\n  b,\n  u,\n  i:not(.far),\n  ul,\n  li {\n    all: revert;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
